export const theme = {
  mainColor1: '#2869E2',
  mainColor2: '#435699',
  mainColor3: '#4E5565',
  subColor1: '#00FFBA',
  subColor2: '#FFB400',
  subColor3: '#DD6868',
  bgColor1: '#F2F4F6',
  errorBgColor: '#FFE4E4',
  errorColor: '#DD6868',
  confirmBgColor: '#F4FFE4',
  confirmColor: '#24BB33',
  inputBorderColor: '#D6DBE1',
  inputPlaceholderColor: '#666',
  inputColor: '#111',
  inputDefaultColor: '#777',
  inputDefaultBackgroundColor: '#F3F3F3',
  bsType1: '0px 2px 6px rgba(188, 191, 209, 0.2)',
};
